// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Under Construction Styles
 */

.under-construction {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 240px); /* Account for navbar + KPIs */
  padding: 2rem;
  background: var(--slate-50, #07090f);
}

.under-construction-content {
  max-width: 600px;
  text-align: center;
  background: var(--bg-card, #0d0f1a);
  border: 1px solid var(--border, rgba(255,255,255,.07));
  padding: 3rem 2rem;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.under-construction-icon {
  font-size: 6rem;
  margin-bottom: 1.5rem;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

.under-construction-title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary, #e2e8f0);
  margin-bottom: 1rem;
}

.under-construction-message {
  font-size: 1.25rem;
  color: var(--text-secondary, rgba(255,255,255,.55));
  margin-bottom: 2rem;
}

.under-construction-details {
  text-align: left;
  background: var(--bg-toolbar, rgba(255,255,255,.04));
  border: 1px solid var(--border, rgba(255,255,255,.07));
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.under-construction-details p {
  font-weight: 600;
  color: var(--text-primary, #e2e8f0);
  margin-bottom: 1rem;
}

.under-construction-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.under-construction-features li {
  padding: 0.5rem 0;
  color: var(--text-secondary, rgba(255,255,255,.55));
  position: relative;
  padding-left: 1.5rem;
}

.under-construction-features li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: var(--accent, #6366f1);
  font-weight: bold;
}

.under-construction-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.under-construction-footer {
  padding-top: 1.5rem;
  border-top: 1px solid var(--border, rgba(255,255,255,.07));
}

.under-construction-footer p {
  margin: 0;
  font-size: 0.9rem;
  color: var(--text-muted, rgba(255,255,255,.35));
}

/* Responsive */
@media (max-width: 768px) {
  .under-construction-content {
    padding: 2rem 1.5rem;
  }

  .under-construction-icon {
    font-size: 4rem;
  }

  .under-construction-title {
    font-size: 1.5rem;
  }

  .under-construction-message {
    font-size: 1rem;
  }

  .under-construction-actions {
    flex-direction: column;
  }

  .under-construction-actions .btn {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .under-construction {
    padding: 1rem;
  }

  .under-construction-content {
    padding: 1.5rem 1rem;
  }

  .under-construction-icon {
    font-size: 3rem;
  }
}

/* Print */
@media print {
  .under-construction {
    background: white;
  }

  .under-construction-icon {
    animation: none;
  }

  .under-construction-actions {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UnderConstruction.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B,EAAE,8BAA8B;EAC/D,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,sDAAsD;EACtD,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,sDAAsD;EACtD,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;EACnD,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,UAAU;AACV;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/**\r\n * Under Construction Styles\r\n */\r\n\r\n.under-construction {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: calc(100vh - 240px); /* Account for navbar + KPIs */\r\n  padding: 2rem;\r\n  background: var(--slate-50, #07090f);\r\n}\r\n\r\n.under-construction-content {\r\n  max-width: 600px;\r\n  text-align: center;\r\n  background: var(--bg-card, #0d0f1a);\r\n  border: 1px solid var(--border, rgba(255,255,255,.07));\r\n  padding: 3rem 2rem;\r\n  border-radius: 16px;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.under-construction-icon {\r\n  font-size: 6rem;\r\n  margin-bottom: 1.5rem;\r\n  animation: bounce 2s infinite;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 20%, 50%, 80%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  40% {\r\n    transform: translateY(-20px);\r\n  }\r\n  60% {\r\n    transform: translateY(-10px);\r\n  }\r\n}\r\n\r\n.under-construction-title {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary, #e2e8f0);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.under-construction-message {\r\n  font-size: 1.25rem;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.under-construction-details {\r\n  text-align: left;\r\n  background: var(--bg-toolbar, rgba(255,255,255,.04));\r\n  border: 1px solid var(--border, rgba(255,255,255,.07));\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.under-construction-details p {\r\n  font-weight: 600;\r\n  color: var(--text-primary, #e2e8f0);\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.under-construction-features {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.under-construction-features li {\r\n  padding: 0.5rem 0;\r\n  color: var(--text-secondary, rgba(255,255,255,.55));\r\n  position: relative;\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.under-construction-features li:before {\r\n  content: \"✓\";\r\n  position: absolute;\r\n  left: 0;\r\n  color: var(--accent, #6366f1);\r\n  font-weight: bold;\r\n}\r\n\r\n.under-construction-actions {\r\n  display: flex;\r\n  gap: 1rem;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.under-construction-footer {\r\n  padding-top: 1.5rem;\r\n  border-top: 1px solid var(--border, rgba(255,255,255,.07));\r\n}\r\n\r\n.under-construction-footer p {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: var(--text-muted, rgba(255,255,255,.35));\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .under-construction-content {\r\n    padding: 2rem 1.5rem;\r\n  }\r\n\r\n  .under-construction-icon {\r\n    font-size: 4rem;\r\n  }\r\n\r\n  .under-construction-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .under-construction-message {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .under-construction-actions {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .under-construction-actions .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .under-construction {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .under-construction-content {\r\n    padding: 1.5rem 1rem;\r\n  }\r\n\r\n  .under-construction-icon {\r\n    font-size: 3rem;\r\n  }\r\n}\r\n\r\n/* Print */\r\n@media print {\r\n  .under-construction {\r\n    background: white;\r\n  }\r\n\r\n  .under-construction-icon {\r\n    animation: none;\r\n  }\r\n\r\n  .under-construction-actions {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
